module.exports = __webpack_public_path__ + "img/bg.3308ab37.jpg";